import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, tap } from 'rxjs';
import {
    LockMonthRequest,
    LockMonthResultDto,
    MonthLockStatusDto,
    ReceiptPeriodLockDto,
    WingDto,
} from './lock-month.types';

@Injectable({ providedIn: 'root' })
export class ReceiptLocksService {
    private _http = inject(HttpClient);
    private readonly _base = environment.apiBaseUrl;

    static lockableWingsExist = false;

    getLockableWings(): Observable<WingDto[]> {
        return this._http.get<WingDto[]>(`${this._base}/receipts/lockable-wings`).pipe(
            tap((wings) => {
                ReceiptLocksService.lockableWingsExist = wings && wings.length > 0;
            })
        );
    }

    getMonthStatus(
        wingId: number,
        year: number,
        month: number
    ): Observable<MonthLockStatusDto> {
        let params = new HttpParams()
            .set('wingId', String(wingId))
            .set('year', String(year))
            .set('month', String(month));

        return this._http.get<MonthLockStatusDto>(`${this._base}/receipts/month-status`, {
            params,
        });
    }

    getLocks(wingId: number): Observable<ReceiptPeriodLockDto[]> {
        let params = new HttpParams().set('wingId', String(wingId));

        return this._http.get<ReceiptPeriodLockDto[]>(`${this._base}/receipts/locks`, {
            params,
        });
    }

    lockMonth(request: LockMonthRequest): Observable<LockMonthResultDto> {
        return this._http.post<LockMonthResultDto>(
            `${this._base}/receipts/lock-month`,
            request
        );
    }

    unlockMonth(request: LockMonthRequest): Observable<void> {
        return this._http.post<void>(`${this._base}/receipts/unlock-month`, request);
    }
}
